export default __webpack_public_path__ + "static/dumpster2-d666db262a6567f616572710b89ba1e1.png";